import request from '@/utils/request'

const api = {
  create: '/api/retail/return/create',
  approve: '/api/retail/return/approve',
  outStock: '/api/retail/return/outStock',
  inStock: '/api/retail/return/inStock',
  cancel: '/api/retail/return/cancel',
  detail: '/api/retail/return/detail',
  list: '/api/retail/return/list'
}

export default api

export function createReturnOrder(parameter) {
  return request({
    url: api.create,
    method: 'post',
    data: parameter
  })
}

export function approveReturnOrder(parameter) {
  return request({
    url: api.approve,
    method: 'post',
    params: parameter
  })
}

export function outStockReturnOrder(parameter) {
  return request({
    url: api.outStock,
    method: 'post',
    params: parameter
  })
}

export function inStockReturnOrder(parameter) {
  return request({
    url: api.inStock,
    method: 'post',
    params: parameter
  })
}

export function cancelReturnOrder(parameter) {
  return request({
    url: api.cancel,
    method: 'post',
    params: parameter
  })
}

export function getReturnOrderDetail(parameter) {
  return request({
    url: api.detail,
    method: 'get',
    params: parameter
  })
}

export function getReturnOrderList(parameter) {
  return request({
    url: api.list,
    method: 'get',
    params: parameter
  })
}
